import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchEmployeeListLimitedData = createAsyncThunk("fetchEmployeeListLimitedData", async (filters = {}) => {
	const params = new URLSearchParams();
	if (filters?.hasSmartPhone === false) {
		params.append("hasSmartPhone", "false");
	}
	const queryString = params.toString();
	const url = queryString ? `employee/list/all-limited?${queryString}` : `employee/list/all-limited`;
	const response = await axiosHttp.get(url);
	return response.data.data;
});

const employeeListLimitedDataSlice = createSlice({
	name: "employeeListLimitedData",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchEmployeeListLimitedData.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchEmployeeListLimitedData.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.page;
			state.total = action.payload.total;
		});
		builder.addCase(fetchEmployeeListLimitedData.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default employeeListLimitedDataSlice.reducer;
